import React from 'react';
import '../constants/AssetsCss';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GetORPostAsync from '../constants/restservice';
import withRouter from '../constants/withRouter';

class MatchingBonus extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sponsorBonusTable : ""
        }
    }
    componentDidMount(){
        this.getMatchingBonus();
    }
    async getMatchingBonus() {
        let res = await GetORPostAsync("GetPairingBonusReport.asp","GET",null,localStorage.getItem("token"));
        if(res.status === "error"){
            if(res.message === "Session Expired"){
                toast(res.message);
                this.props.history.push({
                    pathname:"/"
                });
            }
            this.setState({sponsorBonusTable:"<tr><td colSpan='4'>No Records</td></tr>"});            
            return;
        }
        let str ="";
        for(let i=0;i<res.items.length;i++){
            str += '<tr><td class="bg-color-1 text-white">'+(i+1)+'</td><td>'+res.items[i].payoutdate+'</td><td>'+res.items[i].cashwallet+'</td><td>'+res.items[i].reward+'</td></tr>';    
            if(i === res.items.length - 1){
                this.setState({sponsorBonusTable:str});
            }
        }
    }
    render() {
        return (<div><div className="page-header">
            <div className="page-leftheader">
                <h4 className="page-title mb-0">Hi! {localStorage.getItem('fullname')}</h4>
                {/* <ol className="breadcrumb">
                    <li className="breadcrumb-item"><label><i className="fe fe-home mr-2 fs-14"></i>Bonus Statement</label></li>
                    <li className="breadcrumb-item active" aria-current="page"><label>Matching Bonus</label></li>
                </ol> */}
            </div>
        </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title text-color-3" style={{fontWeight:"200",fontSize:"22px"}}>Matching Bonus Statement</h3>                            
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table style={{textAlign:"center"}} className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top">
                                    <thead className="">
                                        <tr>
                                            <th>S.No</th>
                                            <th>Date</th>
                                            <th>Matching Bonus</th>
                                            <th>Matching Pair</th>
                                        </tr>
                                    </thead>
                                    <tbody dangerouslySetInnerHTML={{__html:this.state.sponsorBonusTable}}>
                                        
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        );
    }
}

export default  withRouter(MatchingBonus);